import { hasMarketBrandLogo } from './brand';

export const DEFAULT_PREDICTION_MARKET = 'kalshi';

/** Kalshi lists every symbol under a `KX` prefix. */
const KALSHI_SYMBOL_PREFIX = 'KX';

/**
 * Which venue's logo to show for a prediction instrument. Uses an explicit venue when it has a
 * brand logo, and falls back to the symbol prefix so Kalshi outcomes without `Markets` still
 * resolve. Returns undefined when no venue can be identified.
 */
export function resolvePredictionCardLogoMarket(
  market: string | undefined,
  symbol: string | undefined
): string | undefined {
  if (hasMarketBrandLogo(market)) {
    return market;
  }
  if (symbol?.toUpperCase().startsWith(KALSHI_SYMBOL_PREFIX)) {
    return DEFAULT_PREDICTION_MARKET;
  }
  return undefined;
}
